import { ProductType } from 'components/shared/Cart/types';
import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

export const deriveDiscountCodesPolicy: CartPolicy = (input, _cart, meta) => {
  const hasUhxLine = (input.lineItemsToAdd ?? []).some(
    (line) => getAttr(line.attributes, '_product_type') === ProductType.UHX,
  );
  if (hasUhxLine) meta.discountOptions.isUhxProductTypePresent = true;

  return pass(input, 'discount option flags resolved (merge deferred to setDiscountCodes)');
};
